import { render } from "./NewsPage.vue?vue&type=template&id=093faf7a&scoped=true"
import script from "./NewsPage.vue?vue&type=script&lang=js"
export * from "./NewsPage.vue?vue&type=script&lang=js"

import "./NewsPage.vue?vue&type=style&index=0&id=093faf7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093faf7a"]])

export default __exports__